import React, { FC } from 'react'
import Heading from '../../../atoms/Heading/Heading'
import { motion } from 'framer-motion'

interface EnterpriseFeaturesProps {
    enterpriseData: any
}

const EnterpriseFeatures: FC<EnterpriseFeaturesProps> = ({ enterpriseData }) => {
    // Animation variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    }

    const cardVariants = {
        hidden: { 
            opacity: 0, 
            y: 50 
        },
        visible: { 
            opacity: 1, 
            y: 0,
            transition: {
                type: "spring",
                stiffness: 100,
                damping: 15
            }
        }
    }

    return (
        <div className='my-16'>
            <Heading subTitle='Key features of Enterprise App development' />
            <motion.div 
                className='grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 px-4 md:px-20 lg:px-40 mt-10 md:mt-20'
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: false, amount: 0.2 }}
            >
                {enterpriseData.EnterpriseFeatures.map((feature: any, idx: number) => {
                    return (
                        <motion.div
                            key={idx}
                            className='flex flex-col gap-4 rounded-3xl p-4 md:p-6 cursor-pointer bg-darkGreySecondary text-white'
                            variants={cardVariants}
                            whileHover={{ 
                                scale: 1.03, 
                                backgroundColor: `${feature.bgColor}`,
                                color: "#000",
                                transition: { duration: 0.3 } 
                            }}
                        >
                            <motion.div className='flex gap-4 md:gap-6 items-center'>
                                <motion.div 
                                    className={`w-12 h-12 md:w-14 md:h-14 rounded-full bg-black text-${feature.color} flex items-center justify-center font-bold text-xl md:text-2xl`}
                                    whileHover={{ 
                                        scale: 1.1, 
                                        transition: { duration: 0.2 } 
                                    }}
                                >
                                    {feature.key}.
                                </motion.div>
                                <div className='font-semibold text-lg md:text-xl'>{feature.title}</div>
                            </motion.div>
                            <div className='text-sm md:text-md pr-2 md:pr-8'>{feature.description}</div>
                        </motion.div>
                    )
                })}
            </motion.div>
        </div>
    )
}

export default EnterpriseFeatures
